import { stopPropagation } from '../../../../../utils/events'
import { useFileDownload } from '../../../../File'

export function useWidgetContentFileItemHandlers({
  file,
  scope,
  onClick,
  onSuccessDownloadFile,
}) {
  const { downloadFile, loading } = useFileDownload({
    apiParams: {
      scope,
    },
    file,
    onSuccess: onSuccessDownloadFile,
  })

  function handleClick() {
    if (!loading) {
      onClick?.(file.id)
    }
  }

  function handleClickDownloadFile(event) {
    stopPropagation(event)

    downloadFile()
  }

  return { handleClick, handleClickDownloadFile, loading }
}
